import { useMemo } from "react";
import { useConfigStore } from "../../store/configStore";

/**
 * 展示当前模版已设置 Pro 价格的 SKU 数量（已设 Pro / 总 SKU）。
 * 对齐普通模版预览左上角的 Pro 统计。
 */
export function ProSkuCount({ className }: { className?: string }) {
  const skus = useConfigStore((s) => s.templateConfig?.skus);

  const { proCount, total } = useMemo(() => {
    const list = Object.values(skus || {});
    return {
      total: list.length,
      proCount: list.filter((sku: any) => (sku?.pro ?? 0) > 0).length,
    };
  }, [skus]);

  if (total === 0) return null;

  return (
    <div
      className={
        className ??
        "absolute top-2 left-2 z-[99999] flex items-center rounded bg-background/80 px-1.5 py-0.5 text-xs shadow-sm"
      }
    >
      <span className="mr-1.5 w-4 text-xs font-semibold">Pro</span>
      {proCount}/{total}
    </div>
  );
}
